import StatusIndicator from './statusIndicator';
import styles from './styles.module.css';
import { DataTableColumn } from '@/components/DataTable';

export const getSearchCompaniesColumns = <
  T extends { status?: string; name: string }
>(): DataTableColumn<T>[] => {
  return [
    {
      field: 'name',
      headerName: 'NAME',
      width: '50%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>{row.name}</div>
      )
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: '50%',
      sortable: true,
      renderCell: ({ row }) => <StatusIndicator location={row} />
    }
  ];
};
